import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_SERVER_URL
})

export const maintenanceAxios = axios.create({
  // キャッシュに保存しない
  headers: {'Cache-Control': 'no-store'}
})

// スラッシュを強制的に付与する
// APIサーバーへのリクエストには必須なため
// instance.interceptors.request.use((config) => {
//   if (config.url[config.url.length-1] !== '/') {
//     config.url += '/'
//   }
//   return config
// })

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })

  failedQueue = []
}

const install = (Vue, options) => {
  instance.defaults.headers.Authorization = options.initialToken !== null ? `jwt ${options.initialToken}` : null
  instance.defaults.baseURL = options.apiUrl? options.apiUrl :process.env.VUE_APP_API_SERVER_URL

  instance.interceptors.response.use(null, async error => {
    const originalRequest = error.config

    // 401エラーでリフレッシュトークンのエンドポイントではない場合
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      // リフレッシュトークンAPIへのリクエストの場合は、リトライしない
      if (originalRequest.url.includes('/auth/token/refresh/')) {
        console.error('リフレッシュトークンが無効です')
        options.authErrorCb()
        return Promise.reject(error)
      }

      if (isRefreshing) {
        // 既にリフレッシュ処理中の場合は、キューに追加して待機
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        }).then(token => {
          originalRequest.headers['Authorization'] = 'jwt ' + token
          return instance(originalRequest)
        }).catch(err => {
          return Promise.reject(err)
        })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        // トークンのリフレッシュを試みる
        const refreshed = await options.refreshTokenCb()

        if (refreshed) {
          const newToken = options.getTokenCb()
          processQueue(null, newToken)
          originalRequest.headers['Authorization'] = 'jwt ' + newToken
          return instance(originalRequest)
        } else {
          // リフレッシュ失敗時はログアウト
          processQueue(new Error('トークンのリフレッシュに失敗しました'), null)
          options.authErrorCb()
          return Promise.reject(error)
        }
      } catch (err) {
        processQueue(err, null)
        options.authErrorCb()
        return Promise.reject(err)
      } finally {
        isRefreshing = false
      }
    }

    // 401以外のエラーはそのまま返す
    return Promise.reject(error)
  })
  Vue.prototype.$axios = instance
}

export default {
  install
}